module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (canUseOpenWith || showRunButton) { ;
__p += '\n<div class=\'preview-action-buttons\'>\n    ';
 if (canUseOpenWith) { ;
__p += '\n        <div class=\'action_icon open dropdown\'>\n            <a href=\'#\' class=\'dropdown-toggle\' data-bs-toggle=\'dropdown\' data-bs-delay=\'{ "show": 1000, "hide": 100 }\'>\n                <div class=\'openActionContainer\'>\n            <span class=\'horizontalIconContainer\'>\n              <div class=\'openInMatlabIcon\' data-bs-toggle=\'tooltip\' data-bs-container=\'.myfilesTitlebar\'\n                   data-bs-delay=\'{ "show": 1000, "hide": 100 }\' data-bs-placement=\'top\' title=\'' +
((__t = (openToolTipText)) == null ? '' : __t) +
'\'></div>\n            </span>\n                    <span class=\'iconText\'>' +
((__t = (viewOpenInMATLABLiveEditor)) == null ? '' : __t) +
'</span>\n                    <div class=\'caretContainer\'><strong class=\'caret\'></strong></div>\n                </div>\n            </a>\n            <ul class=\'dropdown-menu\'>\n                <li role=\'menuitem\'>\n                    <div class=\'action_icon openInMatlabOnline\' data-action=\'openInMO\'>\n              <span class=\'actionMenuText\' data-bs-toggle=\'tooltip\' data-bs-delay=\'{ "show": 1000, "hide": 100 }\'\n                    data-bs-placement=\'top\' title=\'' +
((__t = (openInMOToolTipText)) == null ? '' : __t) +
'\'>' +
((__t = (viewOpenInMOLiveEditor)) == null ? '' : __t) +
'</span>\n                    </div>\n                </li>\n                <li role=\'menuitem\'>\n                    <div class=\'action_icon openInDesktop\' data-action=\'openInDesktop\'>\n              <span class=\'actionMenuText\' data-bs-toggle=\'tooltip\' data-bs-delay=\'{ "show": 1000, "hide": 100 }\'\n                    data-bs-placement=\'top\' title=\'' +
((__t = (openInMDToolTipText)) == null ? '' : __t) +
'\'>' +
((__t = (viewOpenInMDLiveEditor)) == null ? '' : __t) +
'</span>\n                    </div>\n                </li>\n            </ul>\n        </div>\n\n        <!-- Mobile version for small screens -->\n        <div class=\'action_icon openInMatlabMobile\' style=\'display: none;\' data-action=\'openInMO\'>\n        <span class=\'horizontalIconContainer\'>\n          <div class=\'openInMatlabMobileIcon\' data-bs-toggle=\'tooltip\' data-bs-container=\'.myfilesTitlebar\'\n               data-bs-delay=\'{ "show": 1000, "hide": 100 }\' data-bs-placement=\'top\'\n               title=\'' +
((__t = (openToolTipText)) == null ? '' : __t) +
'\'></div>\n        </span>\n            <span class=\'iconText\'>' +
((__t = (viewOpenInMATLABLiveEditor)) == null ? '' : __t) +
'</span>\n        </div>\n    ';
 } ;
__p += '\n\n    ';
 if (showRunButton) { ;
__p += '\n    <div class=\'action_icon run\' data-action=\'run\'>\n    <span class=\'horizontalIconContainer\'>\n      <div class=\'runIcon\'></div>\n    </span>\n        <span class=\'iconText\'>' +
((__t = (viewRunAction)) == null ? '' : __t) +
'</span>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';
 } ;


}
return __p
};
